import StringHelper from "./StringHelper";

import moment from "moment";

export default class DateHelper {
	static convertDate(date, dateOriginalFormat, dateFormat) {
		try {

			if (
				!StringHelper.isString(date) &&
				!StringHelper.isString(dateOriginalFormat) &&
				!StringHelper.isString(dateFormat)
			) {
				return date;
			}

			const momentDate = moment(date, dateOriginalFormat);

			if (momentDate.isValid()) {
				return momentDate.format(dateFormat);
			}
			return date;
		} catch (error) {
			return date;
		}
	}

	static toDate(date) {
		let dateMoment = moment(date);

		if (dateMoment.isValid()) {
			dateMoment = dateMoment.toDate();
		} else {
			dateMoment = null;
		}

		return dateMoment;
	}

	static dateMask(event) {
		let data = event.target.value;

		event.target.setAttribute("maxlength", 10);

		data = data.toString().replace(/(\d\/)*([^\d]*)/g, "$1");


		function addFirstBar(data) {
			const firstData = data.replace(/\//g, "");
			const firstString = firstData.substring(0, 2);
			const secondString = firstData.substring(2, data.length);

			return firstString + "/" + secondString;
		}

		function addSecondBar(data) {
			const firstString = data.substring(0, 5);
			const secondString = data.substring(5, data.length);

			return firstString + "/" + secondString;
		}

		if (data.length >= 3 && data.length < 5) {
			event.target.value = addFirstBar(data);
		} else if (data.length == 6) {
			data = addFirstBar(data);
			event.target.value = addSecondBar(data);
		} else if (data.length >= 10) {
			data = data.toString().substring(0, 10);

			const date = data.split("/");

			if (date.length === 3) {
				let day = date[0];
				let month = date[1];
				let year = date[2];

				if (day.length > 2) {
					month = day.substring(2, day.length) + month;
					day = day.substring(0, 2);
				}

				if (month.length > 2) {
					year = month.substring(2, month.length) + year;
					month = month.substring(0, 2);
				}

				data = day + "/" + month + "/" + year;
			}

			event.target.value = data;
		}
	}

	static dateMaskMonthYear(event) {
		let data = event.target.value;

		event.target.setAttribute("maxlength", 10);

		if (/^\/[\d]*/g.test(data)) {
			return null;
		}

		data = data.toString().replace(/(\d\/)*([^\d]*)/g, "$1");

		function addFirstBar(data) {
			const firstData = data.replace(/\//g, "");
			const firstString = firstData.substring(0, 2);
			const secondString = firstData.substring(2, data.length);

			return firstString + "/" + secondString;
		}

		if (data.length >= 3 && data.length < 5) {
			event.target.value = addFirstBar(data);
		} else if (data.length >= 7) {
			data = data.toString().substring(0, 7);

			const date = data.split("/");

			if (date.length === 2) {
				let month = date[0];
				let year = date[1];

				if (month.length > 2) {
					year = month.substring(2, month.length) + year;
					month = month.substring(0, 2);
				}
				data = month + "/" + year;
			}

			event.target.value = data;
		}
	}
}
